/**
 * 路径配置
 *
 * 分开部署时：
 * - 用户端: 设置 USER_BASE_PATH = '', ADMIN_BASE_PATH = null
 * - 管理端: 设置 USER_BASE_PATH = null, ADMIN_BASE_PATH = ''
 */

// 构建模式检测（可通过环境变量控制）
// BUILD_MODE: 'combined' | 'user' | 'admin'
const BUILD_MODE = process.env.REACT_APP_BUILD_MODE || 'combined';

// 用户端基础路径前缀
export const USER_BASE_PATH = BUILD_MODE === 'admin' ? null : (BUILD_MODE === 'user' ? '' : '/user');

// 管理端基础路径前缀
export const ADMIN_BASE_PATH = BUILD_MODE === 'user' ? null : (BUILD_MODE === 'admin' ? '' : '/admin');

/**
 * 生成用户端路径
 * @param {string} path - 相对路径，如 '/billing/invoices'
 * @returns {string} 完整路径
 */
export const userPath = (path) => {
    if (USER_BASE_PATH === null) {
        console.warn('userPath called in admin-only build');
        return path || '/';
    }
    if (!path) return USER_BASE_PATH || '/';
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${USER_BASE_PATH}${normalizedPath}`;
};

/**
 * 生成管理端路径
 * @param {string} path - 相对路径，如 '/dns/zones'
 * @returns {string} 完整路径
 */
export const adminPath = (path) => {
    if (ADMIN_BASE_PATH === null) {
        console.warn('adminPath called in user-only build');
        return path || '/';
    }
    if (!path) return ADMIN_BASE_PATH || '/';
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${ADMIN_BASE_PATH}${normalizedPath}`;
};

/**
 * 检查当前构建是否包含用户端
 */
export const hasUserMode = () => USER_BASE_PATH !== null;

/**
 * 检查当前构建是否包含管理端
 */
export const hasAdminMode = () => ADMIN_BASE_PATH !== null;

/**
 * Default landing page for a signed-in user in THIS build.
 * The user build (console.yeap.cloud) never routes to admin pages — the admin
 * console is a separate build on spectrum.yeap.cloud.
 */
export const homePathFor = (user) => {
    if (user && user.role === 'admin' && hasAdminMode()) return adminPath('/dashboard');
    if (hasUserMode()) return userPath('/dashboard');
    return adminPath('/dashboard');
};

/**
 * 获取当前构建模式
 */
export const getBuildMode = () => BUILD_MODE;

export default {
    USER_BASE_PATH,
    ADMIN_BASE_PATH,
    userPath,
    adminPath,
    hasUserMode,
    hasAdminMode,
    homePathFor,
    getBuildMode,
};
